// One shared, viewport-clamped tooltip for every .pb-tip (i) in the app.
// A CSS-only bubble gets clipped by a modal's overflow (and can spill off-screen
// near an edge), so we position a single fixed element on the <body> instead and
// clamp it to the viewport. Importing this module self-initializes the listeners.

let tipEl = null;
let activeTarget = null;

const ensureEl = () => {
  if (tipEl) return tipEl;
  tipEl = document.createElement("div");
  tipEl.className = "pb-tooltip";
  tipEl.setAttribute("role", "tooltip");
  document.body.appendChild(tipEl);
  return tipEl;
};

const position = (target, el) => {
  const r = target.getBoundingClientRect();
  const margin = 8;
  const gap = 9;
  const tw = el.offsetWidth;
  const th = el.offsetHeight;

  let left = r.left + r.width / 2 - tw / 2;
  left = Math.max(margin, Math.min(left, window.innerWidth - tw - margin));

  let top = r.top - th - gap;
  const below = top < margin;
  if (below) top = r.bottom + gap;

  el.style.left = `${Math.round(left)}px`;
  el.style.top = `${Math.round(top)}px`;
  // Keep the arrow pointing at the icon even after horizontal clamping.
  el.style.setProperty("--arrow-x", `${Math.round(r.left + r.width / 2 - left)}px`);
  el.classList.toggle("pb-tooltip--below", below);
};

const show = (target) => {
  const text = target.getAttribute("data-tip");
  if (!text) return;
  activeTarget = target;
  const el = ensureEl();
  el.textContent = text;
  position(target, el); // measure + place before fading in
  el.classList.add("pb-tooltip--visible");
};

const hide = () => {
  activeTarget = null;
  tipEl?.classList.remove("pb-tooltip--visible");
};

const tipFrom = (e) => e.target?.closest?.(".pb-tip[data-tip]");

document.addEventListener("pointerover", (e) => {
  const t = tipFrom(e);
  if (t) show(t);
});
document.addEventListener("pointerout", (e) => {
  const t = tipFrom(e);
  if (t && !t.contains(e.relatedTarget)) hide();
});
// Keyboard a11y
document.addEventListener("focusin", (e) => {
  const t = tipFrom(e);
  if (t) show(t);
});
document.addEventListener("focusout", (e) => {
  if (tipFrom(e)) hide();
});
// Touch: a tap toggles; tapping elsewhere dismisses
document.addEventListener("click", (e) => {
  const t = tipFrom(e);
  if (!t) {
    if (activeTarget) hide();
    return;
  }
  if (activeTarget === t) hide();
  else show(t);
});
// A moving page invalidates the fixed position
window.addEventListener("scroll", hide, true);
window.addEventListener("resize", hide);
document.addEventListener("keydown", (e) => {
  if (e.key === "Escape") hide();
});
